import {State} from '../../reducers'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import { useEffect } from 'react'
import { clearLibroComprasModule, getLibrosCompras } from '../../actions/libros/libro-compras.actions'
import TableLibrosCompras from './Components/LibroCompras/TableLibrosCompras'
import { PLANTILLAS } from '../../utils/cargas.utils'
import { ModalDescargarPlantillas } from './Components/LibroVentas/ModalDescargarPlantillas'

const LibroCompras = () => {
  const dispatch = useDispatch();
  const {ventasModalFormatos} = useSelector((state: State) => state.libros)

  const buttonsPlantillas = [
    {
      label: "Detalle de Compras",
      files: [PLANTILLAS.COMPRAS_JSON, PLANTILLAS.COMPRAS_VARIANTE_JSON, PLANTILLAS.COMPRAS_XLSX]
    },
    {
      label: "Anexo Anticipo a cuenta de iva del 2% efectuada al declarante",
      files: [PLANTILLAS.ANEXO_6_JSON, PLANTILLAS.ANEXO_6_XLSX]
    },
  ];

  const init = () => {
    dispatch(clearLibroComprasModule());
    dispatch(getLibrosCompras());
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <BasicLayout>
      {ventasModalFormatos && <ModalDescargarPlantillas buttons={buttonsPlantillas} />}
      <div className='header-link'>
        <Link to={'/mas-opciones'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Libro de IVA para Compras</h3>
      </div>
      <div className='separador'></div>
      <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec5-0b1e6fa6' className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{ height: 'auto' }}>
            <div className='w-layout-vflex card-content'>
              <TableLibrosCompras />
            </div>
          </div>
        </div>
      </div>
    </BasicLayout>
  )
}

export default LibroCompras
